import { createFeatureSelector, createSelector } from "@ngrx/store";
import {  ProvinceState, provinceFeatureKey } from "./province.reducer";

export const getProvinceState = createFeatureSelector<ProvinceState>(provinceFeatureKey);
export const getProvinceList = createSelector(getProvinceState, (state) => state.provinceList);
